import { customElement, property } from 'lit/decorators.js';
import { html, TemplateResult } from 'lit';
import { PageBase } from './helpers/page-base';
import { tlang } from '../../../webmodule-common/other/language/lang';
import { appOutOfDate } from '../../../webmodule-common/other/debug';

import { NullPromise } from '../../../webmodule-common/interop/types/misc';
import { getInternalId } from '../../../webmodule-common/other/ui/databinding/databinding';

@customElement('app-home')
export class AppHome extends PageBase {
  internalId: string = getInternalId();
  // For more information on using properties and state in lit
  // check out this link https://lit.dev/docs/components/properties/
  @property() message = tlang`Welcome!`;
  @property({ type: Number }) contentType = 0;

  private get elementId(): string {
    return `home-page-${this.internalId}`;
  }

  async redirectPath(): NullPromise<string> {
    return '/dealers';
  }

  protected async allowEnter(): Promise<boolean> {
    return false;
  }

  async dispose() {
    //any dashboard data cached would need to be flushed here
    await super.dispose();
  }

  render() {
    if (!this.loggedIn) return html``;
    return html`
      <div id=${this.elementId} class="page-content">
        <div class="page-container">${this.getTemplateForCurrentUser()}</div>
      </div>
    `;
  }

  getTemplateForCurrentUser(): TemplateResult {
    return html`
      <div class="page-dashboard-content">
        <h1>Welcome to the Dealer Module Management Console</h1>
      </div>
    `;
  }

  meta() {
    return {
      title: `SoftTech Dealer License Server`,
      titleTemplate: null,
      description: 'SoftTech dealer CPQ'
    };
  }

  protected async awaken() {
    if (appOutOfDate()) {
      return;
    }

    //if we ever reach this page and we are not logged in
    //then we want to force a page reload which will
    //take us through our full reload process of the apoplication
    //in index.html including the user login process
    if (!this.loggedIn) {
      setTimeout(() => (location.href = ''), 100);
    }
  }

  protected async afterUserConnected() {}
}
